import { ExMutationTree } from "vuex";
import { State, Mutations } from "./types";

const mutations: ExMutationTree<State, Mutations> = {
  getFilesSuccess(state, payload) {
    state.files = payload.files.partner_files;
    state.file_total = payload.files.total;
  }
};

export default mutations;
